import React from 'react'
import PropTypes from 'prop-types'

function FlexItem ({ flexContent, children }) {
  const classNames = flexContent
    ? 'l-flex-item l-flex-item--flex-content'
    : 'l-flex-item'
  return <div className={classNames}>{children}</div>
}

FlexItem.propTypes = {
  flexContent: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default FlexItem
